import { methods } from '@/utils/methods'

// 施設情報

const state = () => ({
  // 一覧情報
  list: {
    facet: {}
  },
  // 詳細情報
  detail: [],
  // 市区町村一覧情報
  cityList: []
})

const getters = {
  list: (state) => state.list,
  detail: (state) => state.detail,
  cityList: (state) => state.cityList
}

const mutations = {
  list(state, list) {
    state.list = list
  },
  detail(state, detail) {
    state.detail = detail
  },
  cityList(state, cityList) {
    state.cityList = cityList
  }
}

const actions = {
  // 一覧取得
  async list({ commit }, params = {}) {
    let apiUrl = '/facilities'
    if (params.area && params.line && params.station) {
      apiUrl = '/stations/nearest'
    }
    const res = await this.$axios.get(methods.getApiBaseUrl() + apiUrl, {
      params,
      validateStatus(status) {
        return status < 500
      }
    })
    if (res.status && res.status === 404) {
      return
    }

    const list = { ...res.data }

    // facet が未宣言か空配列の場合は、空オブジェクトに変換する
    if (!list.facet || Array.isArray(list.facet)) {
      list.facet = {}
    } else {
      const sortedList = {
        event_type: [],
        service: [],
        area: [],
        prefecture: [],
        city: [],
        facility_type: []
      }

      if (list.facet.event_type) {
        // facet.eventTypeをconfigの並びに並べ替え
        sortedList.event_type = methods.sortFacet(
          list.facet.event_type,
          methods.getFacilityEventTypesList()
        )
      }
      if (list.facet.service) {
        // facet.serviceをconfigの並びに並べ替え
        sortedList.service = methods.sortFacet(
          list.facet.service,
          methods.getServiceList()
        )
      }
      if (list.facet.area) {
        // facet.areaをconfigの並びに並べ替え
        sortedList.area = methods.sortFacet(
          list.facet.area,
          methods.getAreaList()
        )
      }
      if (list.facet.prefecture) {
        // facet.prefectureをconfigの並びに並べ替え
        sortedList.prefecture = methods.sortFacet(
          list.facet.prefecture,
          methods.getPrefectureList()
        )
      }
      if (list.facet.city) {
        // facet.cityを名前順に並べ替え
        sortedList.city = methods.sortFacetCity(list.facet.city)
      }
      if (list.facet.facility_type) {
        // facet.facility_typeをconfigの並びに並べ替え
        sortedList.facility_type = methods.sortFacet(
          list.facet.facility_type,
          methods.getFacilityTypeList()
        )
      }
      if (list.facet.stations) {
        // facet.stationsを名前順に並べ替え
        sortedList.stations = methods.sortFacetStation(list.facet.stations)
      }

      list.facet = sortedList
    }

    // ストアに格納
    commit('list', list)
  },
  // 詳細取得
  async detail({ commit }, { id, params }) {
    const res = await this.$axios.get(
      methods.getApiBaseUrl() + '/facilities/' + id,
      {
        params
      }
    )
    commit('detail', res.data)
  },
  // 市区町村一覧取得
  async cityList({ commit }, prefecture = '') {
    let cityList = []

    const firstRow = { name: '市区町村', value: '' }
    commit('cityList', [firstRow])

    if (prefecture) {
      const res = await this.$axios
        .get(methods.getApiBaseUrl() + '/facilities', {
          params: { prefecture, limit: 1, facet: 'city' }
        })
        .catch((e) => {
          this.app.$sentry.captureException(e)
          alert('市区町村の取得に失敗しました')
        })
      if (res && res.data.facet && res.data.facet.city) {
        cityList = res.data.facet.city.map((city) => {
          const cityname = Object.keys(city)[0]
          return { name: cityname, value: cityname }
        })
      }
    }

    cityList.unshift(firstRow)

    // ストアに格納
    commit('cityList', cityList)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
